import React from 'react';
import { Field, inputClasses } from './Field';
interface TextFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  required?: boolean;
  error?: string;
  hint?: string;
  multiline?: boolean;
  className?: string;
}
export function TextField({
  id,
  label,
  value,
  onChange,
  placeholder,
  required,
  error,
  hint,
  multiline,
  className
}: TextFieldProps) {
  const shared = {
    id,
    name: id,
    value,
    placeholder,
    'aria-required': required,
    'aria-invalid': Boolean(error),
    'aria-describedby': error ? `${id}-error` : hint ? `${id}-hint` : undefined,
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => onChange(e.target.value)
  };
  return <Field id={id} label={label} required={required} error={error} hint={hint} className={className} data-id="element-115" data-mp="mv98vpaxqpow">
      {multiline ? <textarea {...shared} rows={3} className={inputClasses(Boolean(error), 'resize-none leading-relaxed')} data-id="element-116" data-mp="rshvc2349fvy" /> : <input {...shared} type="text" autoComplete="off" className={inputClasses(Boolean(error))} data-id="element-117" data-mp="21vmugu8d6mui" />}
    </Field>;
}